<template>
  <div class="modal-overlay">
    <div
      ref="kt_modal_versao_tabela_ibpt"
      data-bs-backdrop="static"
      class="modal fade"
      data-bs-keyboard="false"
      tabindex="-1"
      id="kt_modal_versao_tabela_ibpt"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-body p-0">
            <div class="card">
              <div class="card-header">
                <div class="card-title d-flex align-items-center">
                  <h3 class="fw-bold m-0 text-gray-800">Versão Tabela Ibpt</h3>
                </div>
                <div
                  class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                  data-bs-dismiss="modal"
                  @click="this.$emit('exibirModalVersaoTabelaIbpt', false)"
                >
                  <span class="svg-icon svg-icon-1 svg-icon lh-0">
                    <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                  </span>
                </div>
              </div>
              <div class="card-body pt-8">
                <div class="row">
                  <div class="col-12 mb-4">
                    <label class="form-label me-4">Versão atual</label>
                    <select
                      :id="`versao`"
                      class="form-select mb-0"
                      :class="[getErrorByID(`versao`) ? 'is-invalid' : '']"
                      data-placeholder="Selecione uma opção"
                      v-model="versaoTabelaIbpt.versao"
                    >
                      <template v-for="item in this.versoes" :key="item.versao">
                        <option :value="item.versao">
                          {{
                            `${
                              item.versao
                            } - Vigência Final ${this.$utils.formatarData(
                              item.vigencia_final
                            )}`
                          }}
                        </option>
                      </template>
                    </select>
                    <div
                      v-if="getErrorByID(`versao`)"
                      class="fv-plugins-message-container invalid-feedback"
                    >
                      {{ getErrorByID(`versao`) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer d-flex justify-content-end">
              <button
                class="btn btn-danger svg-icon-white me-2 mb-2"
                data-bs-dismiss="modal"
                @click="this.$emit('exibirModalVersaoTabelaIbpt', false)"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg
                    src="media/icons/duotune/arrows/arr015.svg"
                    class="me-2"
                  />Cancelar
                </span>
              </button>
              <button
                class="btn btn-success svg-icon-white mb-2"
                @click="confirmarVersao()"
                v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
              >
                <span class="indicator-progress">
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-1"
                  ></span>
                  Aguarde...
                </span>
                <span class="svg-icon svg-icon-1" v-if="!this.loading">
                  <inline-svg
                    src="media/icons/duotune/arrows/arr016.svg"
                    class="me-2"
                  />Confirmar
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalVersaoTabelaIbpt'"
    mensagem=""
    v-if="this.loading === true"
  ></LoadingModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModalId, getOrCreateInstanceModal } from "@/core/helpers/dom";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";

export default {
  emits: ["exibirModalVersaoTabelaIbpt", "confirmarVersaoTabelaIbpt"],
  components: {
    LoadingModal,
  },
  methods: {
    getErrorByID(id) {
      return this.errosValidacao[id] &&
        this.errosValidacao[id] !== undefined &&
        this.errosValidacao[id] !== ""
        ? this.errosValidacao[id]
        : null;
    },
    async confirmarVersao() {
      this.errosValidacao = [];
      await this.exibirModalLoading(true);
      try {
        var ret = await this.$store.dispatch(
          "versaoTabelaIbpt/postVersaoTabelaIbpt",
          this.versaoTabelaIbpt
        );
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          await this.showSuccessAlert(ret.Message);
          this.$emit("exibirModalVersaoTabelaIbpt", false);
          this.$emit("confirmarVersaoTabelaIbpt");
          hideModalId("kt_modal_versao_tabela_ibpt");
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        this.errosValidacao = error;
        if (error.Message) {
          await this.showErrorAlert(error);
        }
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loading = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalVersaoTabelaIbpt");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalVersaoTabelaIbpt");
        await this.sleep(100);
        this.loading = false;
      }
    },
    async showSuccessAlert(text) {
      await Swal.fire({
        text: text,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showErrorAlert(text) {
      await Swal.fire({
        text: text,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    async carregarVersoes() {
      try {
        var ret = await this.$store.dispatch("ibpt/getVersoesAgrupadas");
        if (ret.Success === true && ret.Data.length > 0) {
          this.versoes = ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarVersaoAtual() {
      try {
        var ret = await this.$store.dispatch(
          "versaoTabelaIbpt/getVersaoTabelaIbptOData",
          ""
        );
        if (ret !== null && ret.value.length > 0) {
          this.versaoTabelaIbpt = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    await this.carregarVersaoAtual();
    await this.carregarVersoes();
  },
  data() {
    return {
      versoes: [],
      errosValidacao: [],
      versaoTabelaIbpt: {
        id: 0,
        versao: "",
      },
      loading: false,
      timeOut: null,
    };
  },
};
</script>

<style></style>
